import React from 'react';
import {
  Badge,
  Box,
  HStack,
  Skeleton,
  Text,
  VStack,
} from '@chakra-ui/react';
import dayjs from 'dayjs';
import { SaktiRecentActivityItem } from '../types';
import { SAKTI_UI_SIZE } from '../uiSizes';

interface SaktiRecentActivityProps {
  loading: boolean;
  activities: SaktiRecentActivityItem[];
}

const getBadgeColor = (activityType: string) => {
  const normalizedType = activityType.toLowerCase();
  if (normalizedType.includes('transport')) return 'orange';
  if (normalizedType.includes('harvest')) return 'green';
  if (normalizedType.includes('plan')) return 'purple';
  if (normalizedType.includes('maintenance')) return 'yellow';
  return 'blue';
};

const SaktiRecentActivity: React.FC<SaktiRecentActivityProps> = ({ loading, activities }) => {
  return (
    <Skeleton isLoaded={!loading} borderRadius={SAKTI_UI_SIZE.cardRadius} h="100%">
      <Box
        h="100%"
        bg="white"
        borderRadius={SAKTI_UI_SIZE.cardRadius}
        borderWidth="1px"
        borderColor="gray.200"
        p={SAKTI_UI_SIZE.cardPadding}
      >
        <Text fontWeight="bold" fontSize={SAKTI_UI_SIZE.chartTitle} color="customGreen.500" mb={4}>
          RECENT ACTIVITY
        </Text>

        {activities.length === 0 ? (
          <Box h="140px" display="flex" alignItems="center" justifyContent="center">
            <Text color="gray.500" textAlign="center" fontSize="sm">
              Belum ada aktivitas terbaru
            </Text>
          </Box>
        ) : (
          <VStack align="stretch" spacing={2} maxH={{ base: 'full', xl: '620px' }} overflowY="auto">
            {activities.map((activity) => (
              <Box
                key={activity.id}
                borderWidth="1px"
                borderColor="gray.200"
                borderLeftWidth="4px"
                borderLeftColor="customGreen.500"
                borderRadius="lg"
                p={2.5}
                bg="gray.50"
              >
                <HStack justify="space-between" align="start" mb={2}>
                  <Badge colorScheme={getBadgeColor(activity.activity_type)}>
                    {activity.activity_type}
                  </Badge>
                  <Text fontSize="xs" color="gray.500">
                    {dayjs(activity.timestamp).format('HH:mm')}
                  </Text>
                </HStack>

                <Text fontWeight="semibold" color="gray.800" mb={1}>
                  {activity.activity_title}
                </Text>
                <Text fontSize="xs" color="gray.600">
                  {activity.description}
                </Text>
              </Box>
            ))}
          </VStack>
        )}
      </Box>
    </Skeleton>
  );
};

export default SaktiRecentActivity;
